import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Clock3, RefreshCw } from "lucide-react";

export default function PendingApproval() {
  const nav = useNavigate();
  const [sub, setSub] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const load = async () => {
    setRefreshing(true);
    try {
      const { data } = await api.get("/subscription/my");
      setSub(data);
      if (data?.status === "approved") nav("/dashboard");
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-2xl mx-auto py-10 animate-fade-up">
      <div className="rounded-xl border border-border bg-card p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-primary/10 text-primary grid place-items-center">
          <Clock3 className="h-7 w-7" />
        </div>
        <h1 className="mt-6 font-heading font-bold text-3xl">Awaiting admin approval</h1>
        <p className="mt-3 text-muted-foreground max-w-md mx-auto">
          Your subscription request has been submitted. An administrator will review your package and activate access shortly.
        </p>

        {sub && (
          <div className="mt-6 rounded-lg border border-border p-4 text-left text-sm bg-muted/30">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Request details</div>
            <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1">
              <div><span className="text-muted-foreground">Data type:</span> <span className="font-medium">{sub.data_type?.toUpperCase()}</span></div>
              <div><span className="text-muted-foreground">Status:</span> <span className="font-medium capitalize">{sub.status}</span></div>
              <div><span className="text-muted-foreground">Submitted:</span> <span className="num">{new Date(sub.created_at).toLocaleString()}</span></div>
            </div>
          </div>
        )}

        <div className="mt-8 flex items-center justify-center gap-3">
          <Button variant="outline" onClick={load} disabled={refreshing} data-testid="pending-refresh-btn">
            <RefreshCw className={`h-4 w-4 mr-1.5 ${refreshing ? "animate-spin" : ""}`} />
            Refresh
          </Button>
          <Button variant="ghost" onClick={() => nav("/onboarding")} data-testid="pending-edit-btn">
            Change package
          </Button>
        </div>
        <div className="mt-4 text-xs text-muted-foreground">Auto-refreshes every 15s</div>
      </div>
    </div>
  );
}
